var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-center py-5 bg-light" }, [
    _c(
      "svg",
      {
        staticClass: "feather feather-clock",
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      },
      [
        _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
        _vm._v(" "),
        _c("polyline", { attrs: { points: "12 6 12 12 16 14" } }),
      ]
    ),
    _vm._v(" "),
    _c("p", { staticClass: "lead mt-4" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm._f("translate")("This lecture will be available on")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("h4", [_vm._v(_vm._s(_vm.component.left))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }